import { FC, ReactNode } from "react"

export const IfBlock: FC<{
    visible: boolean,
    children: ReactNode,
    elseElement?: ReactNode,
}> = ({ visible, children, elseElement = null }) => {
    return !visible ? <>{elseElement}</> : <>{children}</>
}